module.exports = __webpack_public_path__ + "img/BC_Logo_C.98691aec.svg";